import type { PremiumIconKey } from '@/components/premium/PremiumIconBadge'
import type { PremiumPackage } from '@/types/premium'
import { normalizeMediaUrl } from '@/lib/normalizeMediaUrl'

const PACKAGE_ICONS: PremiumIconKey[] = [
  'layoutGrid',
  'crown',
  'rocket',
  'bookOpen',
  'image',
  'video',
  'megaphone',
  'badgeCheck',
]

export function normalizePremiumPackage(
  pkg: Omit<PremiumPackage, 'icon'> & { icon?: PremiumIconKey },
  index = 0,
): PremiumPackage {
  const images = (pkg.images ?? [])
    .filter((img) => img?.url)
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    .map((img) => ({ ...img, url: normalizeMediaUrl(img.url) }))

  const cover =
    images[0]?.url ??
    (normalizeMediaUrl(pkg.image) || null)

  return {
    ...pkg,
    icon: pkg.icon ?? PACKAGE_ICONS[index % PACKAGE_ICONS.length],
    duration: pkg.duration || 'per package',
    features: pkg.features ?? [],
    image: cover,
    images,
  }
}
